import { classnames } from 'tailwindcss-classnames';

const NRCHeaderSkeleton = (): JSX.Element => {
  return (
    <div className="nrc-header">
      {/* Mobile Header Skeleton - Default to mobile layout to prevent shift */}
      <div className="border-gray-200 border-b bg-white">
        <div className={classnames('flex', 'items-center', 'justify-between', 'p-4')}>
          {/* Logo skeleton */}
          <div className="bg-gray-200 h-8 w-32 animate-pulse rounded" />

          {/* Right side buttons skeleton */}
          <div className="flex items-center space-x-2">
            <div className="bg-gray-200 h-8 w-8 animate-pulse rounded" />
            <div className="bg-gray-200 h-8 w-8 animate-pulse rounded" />
          </div>
        </div>
      </div>

      {/* Navigation skeleton - Hidden by default to match mobile behavior 
      <div className={classnames('hidden')}>
        <div className="border-gray-200 border-b bg-white p-4">
          <div className="space-y-2">
            {[...Array(5)].map((_, index) => (
              <div key={index} className="bg-gray-200 h-4 w-full animate-pulse rounded" />
            ))}
          </div>
        </div>
      </div>
      */}
    </div>
  );
};

export default NRCHeaderSkeleton;
